<p-tabMenu
  [scrollable]="true"
  [activeItem]="items[0]"
  [model]="items"
></p-tabMenu>

<boma-crud-table
  (createSubmit)="onCreateSubmit()"
  (itemDeleted)="onItemDeleted($event)"
  (updateSelection)="handleUpdateSelection($event)"
  (updateSubmit)="onUpdateSubmit()"
  (viewSelection)="handleUpdateSelection($event)"
  [allowDelete]="true"
  [createFormTemplateReference]="createFormTemplate"
  [createFormValid]="createFormGroup.valid"
  [data]="roles$ | async"
  headersValue="Roles"
  [loaded]="loading$ | async"
  [selectableColumns]="columns"
  singularTerm="Role"
  [updateFormTemplateReference]="updateFormTemplate"
  [viewFormTemplateReference]="updateFormTemplate"
  [viewable]="true"
>
</boma-crud-table>

<ng-template #createFormTemplate>
  <form [formGroup]="createFormGroup" class="grid formgrid">
    <div class="field col-12">
      <label> Name: </label>
      <input
        formControlName="name"
        pInputText
        required
        type="text"
        class="w-full"
      />
    </div>

    <div class="field col-12">
      <label> Description </label>
      <textarea
        cols="30"
        formControlName="description"
        pInputText
        rows="2"
        class="w-full"
      ></textarea>
    </div>
    <div class="field col-12" style="display: none">
      <label> Target: </label>
      <span class="p-fluid">
        <p-dropdown
          (onChange)="getTargetPermissions($event.value)"
          [options]="targetTypes"
          appendTo="body"
          formControlName="target"
          placeholder="Select a target"
        ></p-dropdown>
      </span>
    </div>
    <div *ngIf="permissionsList.length > 0" class="field col-12">
      <p-listbox
        [checkbox]="true"
        [multiple]="true"
        [options]="permissionsList"
        formControlName="permissions"
        optionLabel="value"
        [listStyle]="{ 'max-height': '250px' }"
      >
        <ng-template let-permission pTemplate="item">
          {{ permission }}
        </ng-template>
      </p-listbox>
    </div>
  </form>
</ng-template>

<ng-template #updateFormTemplate>
  <form [formGroup]="updateFormGroup" class="grid formgrid">
    <div class="field col-12">
      <label> Name: </label>
      <input
        formControlName="name"
        pInputText
        required
        type="text"
        class="w-full"
      />
    </div>
    <div class="field col-12">
      <label> Description </label>
      <textarea
        cols="30"
        formControlName="description"
        pInputText
        rows="10"
        class="w-full"
      ></textarea>
    </div>

    <div class="field col-12" style="display: none">
      <label> Target: </label>
      <span class="p-fluid">
        <p-dropdown
          (onChange)="getTargetPermissions($event.value)"
          [options]="targetTypes"
          appendTo="body"
          formControlName="target"
          placeholder="Select a target"
        ></p-dropdown>
      </span>
    </div>
    <div *ngIf="permissionsList.length > 0" class="field col-12">
      <p-listbox
        [checkbox]="true"
        [multiple]="true"
        [options]="permissionsList"
        formControlName="permissions"
        optionLabel="value"
        [listStyle]="{ 'max-height': '250px' }"
      >
        <ng-template let-permission pTemplate="item">
          {{ permission }}
        </ng-template>
      </p-listbox>
    </div>
  </form>
</ng-template>
